import { render, staticRenderFns } from "./inline_diff_comment_row.vue?vue&type=template&id=48b996f0"
import script from "./inline_diff_comment_row.vue?vue&type=script&lang=js"
export * from "./inline_diff_comment_row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports